import { useTranslation } from 'react-i18next';
import { MagnifyingGlass } from '@phosphor-icons/react';

interface GroupsFiltersProps {
  search: string;
  onSearchChange: (search: string) => void;
}

export const GroupsFilters = ({ search, onSearchChange }: GroupsFiltersProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col sm:flex-row gap-4 p-4 border-b border-gray-200">
      <div className="flex-1 relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <MagnifyingGlass size={20} className="text-gray-400" />
        </div>
        <input
          type="text"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={t('admin.groups.search.placeholder')}
          className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
        />
      </div>
    </div>
  );
};
